var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var _vm$item$refs;

        var hover = _ref.hover;
        return [_c('v-list-item', _vm._g({}, _vm.hasClickListener ? {
          click: function click() {
            return _vm.$emit('click');
          }
        } : {}), [_c('v-list-item-icon', [_c('v-icon', {
          staticClass: "ml-5 mr-n4"
        }, [_vm._v("mdi-share")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm.item.status ? _c('v-chip', {
          attrs: {
            "color": _vm.item.status === 'completed' ? 'success' : '',
            "x-small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("enums.AttachmentRequestStatusEnum.".concat(_vm.item.status))) + " ")]) : _vm.item.isExpired ? _c('v-chip', {
          attrs: {
            "color": "error",
            "x-small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.states.expired")) + " ")]) : _c('v-chip', {
          attrs: {
            "color": "info",
            "x-small": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("common.states.active")) + " ")]), _vm.item.emailAddresses && _vm.item.emailAddresses.length ? _c('span', [_vm._v(" " + _vm._s(_vm.$t("sign.SignRequestForm.receiver")) + ": " + _vm._s(_vm.item.emailAddresses.join("; ")) + " ")]) : _vm._e()], 1), _c('v-list-item-title', [_vm.hasOpenDetailListener ? _c('a', {
          attrs: {
            "color": _vm.item.expirationColor
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.emitOpenDetail.apply(null, arguments);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.item.title) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.item.title))])]), _c('v-list-item-subtitle', {
          attrs: {
            "small": ""
          }
        }, [!_vm.item.screenOrder && _vm.item.refs.length ? _c('tooltip', {
          attrs: {
            "text": _vm.$t('components.PartnerReportDetail.rental.document', {
              count: _vm.item.refs.length ? 1 : 0
            })
          }
        }, [_c('span', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-file-outline ")]), _vm._v(" " + _vm._s((_vm$item$refs = _vm.item.refs) === null || _vm$item$refs === void 0 ? void 0 : _vm$item$refs.length) + " ")], 1)]) : _vm._e(), _c('tooltip', {
          attrs: {
            "text": _vm.$t('views.booking.ResourceTable.availability')
          }
        }, [_vm.item.validBy ? _c('span', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-calendar-today-outline ")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.validBy", {
          date: _vm.simpleDate(_vm.item.validBy)
        })) + " ")], 1) : _c('span', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-calendar-today-outline ")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.validIndefinitely")) + " ")], 1)]), _c('tooltip', {
          attrs: {
            "text": _vm.$t('createdBy')
          }
        }, [_vm.item.isSystemGenerated ? _c('span', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-robot-outline ")]), _vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemDocument.systemgenerated")) + " ")], 1) : _vm.item.userId && _vm.getUserNameForId(_vm.item.userId) ? _c('span', [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-account-outline ")]), _vm._v(" " + _vm._s(_vm.getUserNameForId(_vm.item.userId)) + " ")], 1) : _vm._e()])], 1)], 1), _vm.confirmable ? _c('v-list-item-action', {
          staticClass: "mx-0 px-0"
        }, [_c('tooltip', {
          attrs: {
            "text": _vm.$t('project.ticket.actions.copyLink')
          }
        }, [_c('v-flex', [hover ? _c('v-btn', {
          attrs: {
            "text": "",
            "color": "success",
            "elevation": "0",
            "small": ""
          },
          on: {
            "click": _vm.copyLinkToClipboard
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("components.CopyClipboardText.copy")) + " "), _c('v-icon', {
          staticClass: "pl-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v(" mdi-content-copy ")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }